import PropTypes from 'prop-types';
import connectConfigureRelatedItems from "../connectors/connectConfigureRelatedItems.js";
function ConfigureRelatedItems() {
  return null;
}
ConfigureRelatedItems.propTypes = {
  hit: PropTypes.object.isRequired,
  matchingPatterns: PropTypes.object.isRequired,
  transformSearchParameters: PropTypes.func
};
export default connectConfigureRelatedItems(ConfigureRelatedItems, {
  $$widgetType: 'ais.configureRelatedItems'
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-instantsearch-core/dist/es/widgets/ConfigureRelatedItems.js
// module id = 563
// module chunks = 1